import React from "react";
import { useForm } from "react-hook-form";
import { updateDb } from "../services/updateDb";

import { useNavigate, useSearchParams } from "react-router-dom";
import useAxiosFetch from "../common/useAxiosFetch";

import LoadPage from "../common/LoadPage";
import OrganizationForm from "./OrganizationForm";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";

const EditOrganizationPage = () => {
  const { t } = useTranslation();
  const { currentUser, currentOrg, setCurrentOrg, triggerHeaderRefresh } = useAppContext();
  const [searchParams] = useSearchParams();
  const orgId = searchParams.get("orgId");

  const { data, loading } = useAxiosFetch("/api/organizations/" + orgId);

  const navigate = useNavigate();
  const { register, handleSubmit, setValue } = useForm();
  const onSubmit = async (data) => {

    let orgObj = {
      name: data.name,
      ownerUserId: data.ownerUserId,
      description: data.description,
      securityStandard: data.securityStandard,
      rangeBounds: data.rangeBounds.split(',').map(Number)
    };

    const res = await updateDb("/api/organizations/update/" + orgId, orgObj);

    if (res.success) {
      triggerHeaderRefresh();
      navigate("/organizations", { state: { message: t('organization') + " " + t('updated'), type: "warning" } });

      // when updating currentOrg, use setCurrentOrg to apply rangeBounds
      if (currentOrg.id === orgId) {
        setCurrentOrg({ ...currentOrg, name: orgObj.name, rangeBounds: orgObj.rangeBounds, securityStandard: orgObj.securityStandard });
      }
    }
  };

  if (loading || !data.name)
    return <LoadPage />;
  return (
    <div id="content">
      <div id="content-title">{t('update_organization')}</div>

      <div className="content-bubble">
        <OrganizationForm
          register={register}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          text={t('update_organization')}
          setValue={setValue}
          orgData={data}
          currentUser={currentUser}
        />
      </div>
    </div>
  );
};

export default EditOrganizationPage;
